import { 
  getForecasterTweets, 
  getForecasterTelegram 
} from "@/Groups/Forecasters/private/api/getData";

import { 
  getForecasterDailyHighlightsTweets, 
  getForecasterDailyHighlightsTelegram 
} from "@/Groups/Forecasters/private/api/dailyHighlights";

import { 
  getForecasterUserAssetsTweets, 
  getForecasterUserAssetsTelegram 
} from "@/Groups/Forecasters/private/api/userAssets";

import { 
  fetchForecasterByUrl
} from "@/Groups/Forecasters/private/api/nextPagination";

import { 
  searchForecasterByCoinTwitter, 
  searchForecasterByCoinTelegram 
} from "@/Groups/Forecasters/private/api/searchForecasterByCoin";

export default {
  namespaced: true,

  // --------------------------- STATE ---------------------------
  state: {
    activeIndex: 0,

    filters: {
      isDailyFilterActived: false,
      isUserBriefcaseFilterActived: false,
      selectedCoin: null,
    },

    twitter: {
      list: {},
      renderMap: {},
      listDailyHighlights: {},
      count: 0,
      next: null,
      previous: null,
      isLoading: false,
      isReady: false,
      isEnglishLang: false,
    },

    telegram: {
      list: {},
      renderMap: {},
      listDailyHighlights: {},
      count: 0,
      next: null,
      previous: null,
      isLoading: false,
      isReady: false,
      isEnglishLang: false,
    },
  },

  // --------------------------- ACTIONS ---------------------------
  actions: {
    setActiveTab({ commit }, index) {
      commit("SET_ACTIVE_TAB", index);
    },

    // Инициализация (загрузка стандартных данных)
    async init({ dispatch }) {
      await dispatch("fetchDataAll");
    },

    // Основная загрузка без фильтров
    async fetchDataAll({ commit }) {
      commit("SET_LOADING", { type: "twitter", value: true });
      commit("SET_LOADING", { type: "telegram", value: true });

      try {
        const [twitterData, telegramData] = await Promise.all([
          getForecasterTweets(),
          getForecasterTelegram(),
        ]);

        commit("ADD_ITEMS", { type: "twitter", itemsByDate: twitterData.twitter });
        commit("ADD_ITEMS", { type: "telegram", itemsByDate: telegramData.telegram });
        commit("SET_PAGINATION", { type: "twitter", ...twitterData });
        commit("SET_PAGINATION", { type: "telegram", ...telegramData });
        commit("SET_READY", { type: "twitter", value: true });
        commit("SET_READY", { type: "telegram", value: true });
      } catch (error) {
        console.error("fetchDataAll error:", error);
        commit("CLEAR_ITEMS", "twitter");
        commit("CLEAR_ITEMS", "telegram");
      } finally {
        commit("SET_LOADING", { type: "twitter", value: false });
        commit("SET_LOADING", { type: "telegram", value: false });
      }
    },

    // ------------------- DAILY HIGHLIGHTS -------------------
    async toggleDailyFilter({ state, commit, dispatch }) {
      const isActive = !state.filters.isDailyFilterActived;

      // Сбрасываем остальные фильтры и монету
      commit("SET_FILTERS", {
        isDailyFilterActived: isActive,
        isUserBriefcaseFilterActived: false,
        selectedCoin: null,
      });

      commit("CLEAR_ITEMS", "twitter");
      commit("CLEAR_ITEMS", "telegram");
      commit("SET_LOADING", { type: "twitter", value: true });
      commit("SET_LOADING", { type: "telegram", value: true });

      if (isActive) {
        try {
          const [twitterData, telegramData] = await Promise.all([
            getForecasterDailyHighlightsTweets(),
            getForecasterDailyHighlightsTelegram(),
          ]);

          commit("SET_DAILY_HIGHLIGHTS", { type: "twitter", highlights: twitterData.daily_highlights });
          commit("SET_DAILY_HIGHLIGHTS", { type: "telegram", highlights: telegramData.daily_highlights });
          commit("SET_READY", { type: "twitter", value: true });
          commit("SET_READY", { type: "telegram", value: true });
        } catch (error) {
          console.error("toggleDailyFilter error:", error);
        }
      } else {
        await dispatch("resetAll");
      }

      commit("SET_LOADING", { type: "twitter", value: false });
      commit("SET_LOADING", { type: "telegram", value: false });
    },

    // ------------------- USER ASSETS -------------------
    async fetchUserAssetsData({ commit, dispatch }) {
      commit("SET_FILTERS", {
        isDailyFilterActived: false,
        isUserBriefcaseFilterActived: true,
        selectedCoin: null,
      });

      commit("CLEAR_ITEMS", "twitter");
      commit("CLEAR_ITEMS", "telegram");
      commit("SET_LOADING", { type: "twitter", value: true });
      commit("SET_LOADING", { type: "telegram", value: true });

      try {
        const [twitterData, telegramData] = await Promise.all([
          getForecasterUserAssetsTweets(),
          getForecasterUserAssetsTelegram(),
        ]);

        commit("ADD_ITEMS", { type: "twitter", itemsByDate: twitterData.twitter });
        commit("ADD_ITEMS", { type: "telegram", itemsByDate: telegramData.telegram });
        commit("SET_READY", { type: "twitter", value: true });
        commit("SET_READY", { type: "telegram", value: true });
      } catch (error) {
        console.error("fetchUserAssetsData error:", error);
      } finally {
        commit("SET_LOADING", { type: "twitter", value: false });
        commit("SET_LOADING", { type: "telegram", value: false });
      }
    },

    // ------------------- COIN SEARCH -------------------
    addCoinToStore({ commit, dispatch }, coin) {
      // Сбрасываем фильтры, выбираем монету
      commit("SET_FILTERS", {
        isDailyFilterActived: false,
        isUserBriefcaseFilterActived: false,
        selectedCoin: coin,
      });

      dispatch("fetchCoinDataAll");
    },

    async fetchCoinDataAll({ state, commit }) {
      const coin = state.filters.selectedCoin;
      if (!coin) return;

      commit("CLEAR_ITEMS", "twitter");
      commit("CLEAR_ITEMS", "telegram");
      commit("SET_LOADING", { type: "twitter", value: true });
      commit("SET_LOADING", { type: "telegram", value: true });

      try {
        const [twitterData, telegramData] = await Promise.all([
          searchForecasterByCoinTwitter(coin.api_id),
          searchForecasterByCoinTelegram(coin.api_id),
        ]);

        commit("ADD_ITEMS", { type: "twitter", itemsByDate: twitterData.twitter });
        commit("ADD_ITEMS", { type: "telegram", itemsByDate: telegramData.telegram });
        commit("SET_READY", { type: "twitter", value: true });
        commit("SET_READY", { type: "telegram", value: true });
      } catch (error) {
        console.error("fetchCoinDataAll error:", error);
      } finally {
        commit("SET_LOADING", { type: "twitter", value: false });
        commit("SET_LOADING", { type: "telegram", value: false });
      }
    },

    // ------------------- RESET -------------------
    async resetAll({ commit, dispatch }) {
      commit("SET_FILTERS", {
        isDailyFilterActived: false,
        isUserBriefcaseFilterActived: false,
        selectedCoin: null,
      });
      commit("CLEAR_ITEMS", "twitter");
      commit("CLEAR_ITEMS", "telegram");
      await dispatch("fetchDataAll");
    },

    // ------------------- PAGINATION -------------------
    async fetchNextPage({ state, commit }, type) {
      if (!state[type].next) return;
      commit("SET_LOADING", { type, value: true });

      try {
        const data = await fetchForecasterByUrl(state[type].next);
        commit("ADD_ITEMS", { type, itemsByDate: data[type] });
        commit("SET_PAGINATION", { type, ...data });
      } catch (error) {
        console.error(`${type}/fetchNextPage error:`, error);
      } finally {
        commit("SET_LOADING", { type, value: false });
      }
    },

    // ------------------- LANGUAGE -------------------
    toggleLanguage({ state, commit }, type) {
      commit("SET_LANGUAGE", { type, value: !state[type].isEnglishLang });
    },
  },

  // --------------------------- MUTATIONS ---------------------------
  mutations: {
    SET_ACTIVE_TAB(state, index) {
      state.activeIndex = index;
    },

    SET_FILTERS(state, payload) {
      state.filters = { ...state.filters, ...payload };
    },

    ADD_ITEMS(state, { type, itemsByDate }) {
      if (!itemsByDate) return;
      const postKey = type === "twitter" ? "tweets" : "telegram";

      Object.entries(itemsByDate).forEach(([date, data]) => {
        if (!state[type].renderMap[date]) state[type].renderMap[date] = [];
        state[type].listDailyHighlights[date] = data.daily_highlight || null;

        if (Array.isArray(data[postKey])) {
          data[postKey].forEach((item) => {
            if (!state[type].renderMap[date].includes(item.id)) {
              state[type].renderMap[date].unshift(item.id);
            }
            if (!state[type].list[item.id]) {
              state[type].list[item.id] = { ...item };
            }
          });
        }
      });

      Object.keys(state[type].renderMap).forEach((date) => {
        state[type].renderMap[date].sort((a, b) => {
          const tA = new Date(state[type].list[a]?.created_at).getTime();
          const tB = new Date(state[type].list[b]?.created_at).getTime();
          return tB - tA;
        });
      });
    },

    SET_DAILY_HIGHLIGHTS(state, { type, highlights }) {
      const postKey = type === "twitter" ? "tweets" : "telegram";

      Object.entries(highlights).forEach(([date, highlightObj]) => {
        state[type].listDailyHighlights[date] =
          highlightObj.daily_highlights?.[0] || null;
        if (!state[type].renderMap[date]) state[type].renderMap[date] = [];

        if (Array.isArray(highlightObj[postKey])) {
          highlightObj[postKey].forEach((item) => {
            if (!state[type].renderMap[date].includes(item.id)) {
              state[type].renderMap[date].unshift(item.id);
            }
            if (!state[type].list[item.id]) {
              state[type].list[item.id] = { ...item };
            }
          });
        }
      });
    },

    SET_PAGINATION(state, { type, count, next, previous }) {
      state[type].count = count;
      state[type].next = next;
      state[type].previous = previous;
    },

    SET_LOADING(state, { type, value }) {
      state[type].isLoading = value;
    },

    SET_READY(state, { type, value }) {
      state[type].isReady = value;
    },

    CLEAR_ITEMS(state, type) {
      state[type].list = {};
      state[type].renderMap = {};
      state[type].count = 0;
      state[type].next = null;
      state[type].previous = null;
      state[type].isReady = false;
    },

    SET_LANGUAGE(state, { type, value }) {
      state[type].isEnglishLang = value;
    },
  },

  // --------------------------- GETTERS ---------------------------
  getters: {
    activeIndex: (state) => state.activeIndex,
    isDailyFilterActived: (state) => state.filters.isDailyFilterActived,
    isUserBriefcaseFilterActived: (state) => state.filters.isUserBriefcaseFilterActived,
    selectedCoin: (state) => state.filters.selectedCoin,
    list: (state) => (type) => state[type].list,
    renderMap: (state) => (type) => state[type].renderMap,
    isLoading: (state) => (type) => state[type].isLoading,
    isReady: (state) => (type) => state[type].isReady,
    nextPage: (state) => (type) => state[type].next,
    listDailyHighlights: (state) => (type) => state[type].listDailyHighlights,
    isEnglishLang: (state) => (type) => state[type].isEnglishLang,
  },
};